import { Text } from '@cellula/react';
import { HStack } from '@components/h_stack.component';
import { VStack } from '@components/v_stack.component';
import { FlexibleListDirectionalModel } from '@services/flexible_component/mod';
import styled from 'styled-components';
import { FlexibleIdentifier } from './flexible_identifier.component';

interface Props {
	component: FlexibleListDirectionalModel;
}

const elements = {
	container: styled.div`
		display: flex;
		flex-direction: column;
	`,
};

export function FlexibleListDirectional({ component }: Props): JSX.Element {
	const children = component.items.map((item) => <FlexibleIdentifier key={item.id} component={item} />);

	return (
		<elements.container data-testid='FlexibleListDirectional'>
			{component.title && <Text variant='bodySmallRegular'>{component.title}</Text>}
			{component.direction === 'Horizontal' && <HStack>{children}</HStack>}
			{component.direction === 'Vertical' && <VStack>{children}</VStack>}
		</elements.container>
	);
}
